// test1417
(1417 && 0);
